import { render, staticRenderFns } from "./GeneralDoughnutChartComponent.vue?vue&type=template&id=abb7f5e0&"
import script from "./GeneralDoughnutChartComponent.vue?vue&type=script&lang=js&"
export * from "./GeneralDoughnutChartComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports